import { NotificationTypeEnum } from '@/types/enums/notification-type-enum';
import { routeManager } from '../route';

type PathFn = (id: string) => string;

export class NotificationManager {
    private static instance: NotificationManager;
    private pathMap = new Map<NotificationTypeEnum, PathFn>([
        [
            NotificationTypeEnum.TICKET,
            id =>
                routeManager.getRouteMap()[routeManager.TICKET_DETAIL].path(id),
        ],
        [
            NotificationTypeEnum.TASK,
            id => routeManager.getRouteMap()[routeManager.TASK_DETAIL].path(id),
        ],
        [
            NotificationTypeEnum.ERROR_DETAIL_TASK_CHECK,
            id =>
                routeManager
                    .getRouteMap()
                    [routeManager.ERROR_DETAIL_TASK_CHECK_DETAIL].path(id),
        ],
        [
            NotificationTypeEnum.VIOLATION_DETAIL_TASK_CHECK,
            id =>
                routeManager
                    .getRouteMap()
                    [routeManager.VIOLATION_CUSTOMER_DETAIL].path(id),
        ],
        [
            NotificationTypeEnum.DEVICE,
            id =>
                routeManager.getRouteMap()[routeManager.DEVICE_DETAIL].path(id),
        ],
        [
            NotificationTypeEnum.Warranty,
            id =>
                routeManager.getRouteMap()[routeManager.DEVICE_DETAIL].path(id),
        ],
    ]);

    private titleMap = new Map<NotificationTypeEnum, string>([
        [NotificationTypeEnum.DEVICE, 'Thiết bị'],
        [NotificationTypeEnum.TASK, 'Task'],
        [NotificationTypeEnum.TICKET, 'Ticket'],
        [
            NotificationTypeEnum.VIOLATION_DETAIL_TASK_CHECK,
            'Sai phạm khách hàng',
        ],
        [NotificationTypeEnum.ERROR_DETAIL_TASK_CHECK, 'Sự cố & Sửa chữa'],
        [NotificationTypeEnum.Warranty, 'Hạn bảo hành thiết bị'],
    ]);

    private constructor() {}

    public static getInstance() {
        if (!this.instance) this.instance = new NotificationManager();

        return this.instance;
    }

    public getPath(type: string, id: string): string {
        const fn = this.pathMap.get(type as NotificationTypeEnum);

        return fn ? fn(id) : '/';
    }

    public getTitle(type: NotificationTypeEnum): string {
        return this.titleMap.get(type) ?? 'Thông báo';
    }
}
